import React, { useState } from 'react';
import { Box, Slider, Typography, Stack } from '@mui/material';

const MonthRangeSlider: React.FC<{ months: string[] }> = ({ months }) => {
  const length = months.length - 1;
  const [range, setRange] = useState<[number, number]>([0, length]);

  const handleChange = (_: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      setRange([Math.min(...newValue), Math.max(...newValue)]);
    }
  };
  const uniqueMonths = Array.from(new Set(months.map((date) => date.slice(0, 7))));

  return (
    <Box
      sx={{
        width: '95%',
        marginRight: 'auto',
        marginLeft: 'auto',
        position: 'relative',
      }}
    >
      <Slider
        value={range}
        min={0}
        max={11}
        step={1}
        onChange={handleChange}
        valueLabelDisplay="off"
        sx={{
          color: 'primary.main',
          position: 'relative',
          '& .MuiSlider-thumb': {
            width: '2rem',
            height: '2rem',
            borderRadius: '0.5rem',
            backgroundColor: '#2F736E',
            color: '#FFFFFF',
            zIndex: 2,
            '&:hover, &.Mui-focusVisible': {
              boxShadow: '0 0 0 8px rgba(25, 118, 210, 0.16)',
            },
            '&::after': {
              content: '"="',
              transform: 'rotate(-90deg)',
              top: '-14px',
              left: '-0.5rem',
              fontSize: '2rem',
              fontWeight: 400,
              zIndex: 2,
              color: '#FFF',
            },
          },
          '& .MuiSlider-track': {
            border: 'none',
            height: '2rem',
            backgroundColor: '#AECBD0',
          },
          '& .MuiSlider-rail': {
            opacity: 0.3,
            height: '2rem',
            backgroundColor: '#bfbfbf',
            borderRadius: '0.25rem',
          },
        }}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          width: '100%',
          height: '2rem',
          px: 3,
          zIndex: 1,
          position: 'absolute',
          top: 0,
          pointerEvents: 'none',
          gap: '0.25rem',
          alignItems: 'center',
        }}
      >
        {uniqueMonths.map((month, index) => (
          <Typography
            key={index}
            variant="caption"
            sx={{
              width: 'fit-content',
              textAlign: 'center',
              color: '#ECECEC',
              fontWeight: 700,
              fontSize: '0.875rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              userSelect: 'none',
            }}
          >
            {month}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
};

export default MonthRangeSlider;
